//
//
//
//
//
//
//
//
//
//

import IndexHead from '../components/indexHead'
export default {
  name: '404',
  components: {
    IndexHead
  },
  data() {
    return {
    }
  },
  methods: {
  }

}



// WEBPACK FOOTER //
// ./src/pages/404.vue